import { Button, Tabs } from 'antd';

import { useTranslation } from 'react-i18next';

import { useNavigate } from 'react-router-dom';

import type { TabsProps } from 'antd';
import ResidentsForm from '@components/Counterparties/forms/Residents';
import ForeigsForm from '@components/Counterparties/forms/Foreigs';

function CounterpartiesCreate() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: t('Residents'),
      children: <ResidentsForm />,
    },
    {
      key: '2',
      label: t('Foreigs'),
      children: <ForeigsForm />,
    },
  ];

  return (
    <div className='flex justify-center'>
      <div className='lg:w-[1130px] w-full max-lg:px-4'>
        <div className='flex'>
          <div className='py-4 lg:py-8 w-full h-full bg-white mb-12'>
            <div>
              <div className='flex justify-between items-center'>
                <h1 className='max-md:hidden text-xl mb-2 font-semibold color-active'>{t('New counterparty')}</h1>
                <Button
                  type='primary'
                  onClick={() => {
                    navigate('/counterparties');
                  }}
                >
                  {t('Back')}
                </Button>
              </div>
              <div className='mt-1'>
                <Tabs defaultActiveKey='1' items={items} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CounterpartiesCreate;
